import React from "react";
import FlipCard from "./flipCard/FlipCard";
import OrtivisQuestionSingleChoice from "./flipCard/OrtivisQuestionSingleChoice";
import OrtivisQuestionMultiChoice from "./flipCard/OrtivisQuestionMultiChoice";

const OrtivisQuestions = ({
	quiz,
	question,
	onAnswer,
	quizResults,
	setQuizResults,
	handleNext,
}) => {
	const { type } = question;

	return (
		<>
			{type === "single-choice" && (
				<OrtivisQuestionSingleChoice
					quiz={quiz}
					question={question}
					onAnswer={onAnswer}
					quizResults={quizResults}
					setQuizResults={setQuizResults}
					handleNext={handleNext}
				/>
			)}

			{type === "multiple-choice" && (
				<OrtivisQuestionMultiChoice
					quiz={quiz}
					question={question}
					onAnswer={onAnswer}
					quizResults={quizResults}
					setQuizResults={setQuizResults}
					handleNext={handleNext}
				/>
			)}
		</>
	);
};

export default OrtivisQuestions;
